import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
import { ContactTypeList } from '@/components/modules/pages/contact/list/ContactTypeList';
import { TopSectionHead } from '@/components/modules/pages/top/typography/head/TopSectionHead';
import { tailwindConfig } from '@/style/config';
import { PROFFIT_TOP_BG_GRADATION } from '@/utils/constants/assets/s3';
const { theme } = tailwindConfig;
export const TopContact = (props) => {
    const { className = '' } = props;
    const bgImageStyle = css `
    background-image: url(${PROFFIT_TOP_BG_GRADATION.sp.webp});

    @media screen and (min-width: ${theme.screens.lg}) {
      background-image: url(${PROFFIT_TOP_BG_GRADATION.pc.webp});
    }
  `;
    return (_jsxs("div", Object.assign({ className: clsx('bg-cover bg-center bg-no-repeat', 'pt-40 px-20 pb-64 lg:py-80', className), css: bgImageStyle }, { children: [_jsx(TopSectionHead, Object.assign({ color: 'white' }, { children: "\u5404\u7A2E\u304A\u554F\u3044\u5408\u308F\u305B" })), _jsx(ContactTypeList, { className: clsx('mt-24 lg:mt-40 mx-auto', 'lg:w-[1020px] lg:max-w-full') })] })));
};
